module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-header"
  }, [_c('a', {
    class: {
      active: _vm.loginway == 'login'
    },
    on: {
      "click": function($event) {
        _vm.changeLoginWay('login')
      }
    }
  }, [_vm._v("    登录    ·")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.loginway == 'register'
    },
    on: {
      "click": function($event) {
        _vm.changeLoginWay('register')
      }
    }
  }, [_vm._v("    注册    ")])]), _vm._v(" "), (_vm.loginway === 'login') ? _c('div', {
    staticClass: "login-input"
  }, [_c('form', {
    staticClass: "form_login",
    attrs: {
      "action": "http://localhost:5480/WebApp/login.php",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "span2",
    attrs: {
      "type": "text",
      "name": "register_name",
      "placeholder": "选一个昵称"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "span2",
    attrs: {
      "type": "password",
      "name": "register_password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "login-btn btn",
    on: {
      "click": _vm.verify
    }
  }, [_c('span', [_vm._v("登录")])]), _vm._v(" "), _c('div', {
    staticClass: "login-control",
    staticStyle: {
      "color": "#555555",
      "font-size": "12px"
    }
  }, [_c('span', {
    staticClass: "checkbox",
    class: {
      checked: _vm.checked === true
    },
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.checked = !_vm.checked
      }
    }
  }, [_c('input', {
    staticStyle: {
      "position": "absolute",
      "opacity": "0"
    },
    attrs: {
      "type": "checkbox",
      "checked": "checked"
    }
  }), _vm._v(" "), _c('ins', {
    staticClass: "check"
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("记住我")]), _vm._v(" "), _vm._m(2)])])]) : _vm._e(), _vm._v(" "), (_vm.loginway === 'register') ? _c('div', {
    staticClass: "login-input"
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#555555"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("忘记密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form_register",
    attrs: {
      "method": "post",
      "action": "http://localhost:5480/WebApp/register.php"
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })]), _vm._v(" "), _c('input', {
    staticClass: "span2",
    attrs: {
      "type": "text",
      "name": "email_adress",
      "placeholder": "你的邮件地址"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    staticClass: "span2",
    attrs: {
      "type": "text",
      "name": "sign_in[name]",
      "placeholder": "手机号码/电子邮件"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password"
  }, [_c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt"
  })]), _vm._v(" "), _c('input', {
    staticClass: "span2",
    attrs: {
      "type": "password",
      "name": "sign_in[password]",
      "placeholder": "密码"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "register-btn btn",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', [_vm._v("注册")])]), _vm._v(" "), _c('p', {
    staticClass: "register_text"
  }, [_vm._v("点击 “注册” 或下方社交登录按钮，即表示您同意并愿意遵守简书 "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("用户协议")]), _vm._v(" 和 "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("隐私政策")]), _vm._v(" 。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-way"
  }, [_c('h5', [_vm._v("您还可以通过以下方式登录")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "qqicon"
  }, [_c('i', {
    staticClass: "fa fa-qq"
  })]), _vm._v(" "), _c('li', {
    staticClass: "weiboicon"
  }, [_c('i', {
    staticClass: "fa fa-weibo"
  })]), _vm._v(" "), _c('li', {
    staticClass: "wechaticon"
  }, [_c('i', {
    staticClass: "fa fa-wechat"
  })]), _vm._v(" "), _c('li', {
    staticClass: "googleicon"
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('li', {
    staticClass: "githubicon"
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b7b336"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 64
// module chunks = 0